import React from 'react';
import { Link } from 'react-router-dom';
import bimeh from '../assets/images/main_images/error-img.png';

 const NotFound = () => {
  return (
    <div className="account-pages">
    <div className="container">
        <div>
            <div className="col-md-24 col-lg-24 col-xl-24">
                <div className="card overflow-hidden">
                    <div className="card-body">
                        <div className="text-center p-3">
                            <div className="img">
                                <img src={bimeh} className="img-fluid" alt=""/>
                            </div>
                            <h1 className="error-page mt-5"><span>404!</span></h1>
                            <h4 className="mb-4 mt-5">صفحه مورد نظر یافت نشد</h4>
                            <Link className="btn btn-primary mb-4 waves-effect waves-light" to="/dashboard"><i className="mdi mdi-home"></i> بازگشت به داشبورد</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
};
export default NotFound;

